import styled from 'styled-components';

import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';

export const CreateAttrBtn = styled(PrimaryButtonLoading)`
  margin-left: 15px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
